/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Observable, Subject } from 'rxjs';
import { SearchTag } from '../../model/search-tag';
import { HttpFilter } from '../../engine/http/http-filter';
import { CommonUtils } from '../../tool/common-utils';

export abstract class SearchManager {
  /**
   * tags to display
   */
  public tags: SearchTag[] = [];

  /**
   * tags stored in a observable to communicate with the component
   */
  public observableTags = new Subject<SearchTag[]>();

  /**
   * let the creation of tags for the child class
   */
  protected abstract generateTags();

  protected abstract getData();

  /**
   * update the attribut of the data
   * @param tag
   */
  protected abstract updateData(tag: SearchTag);

  /**
   * create tags that will be display in the banner
   */
  public createTags() {
    this.generateTags();
    this.notify();
  }

  /**
   *  Return the observable of new tags
   */
  getTags(): Observable<SearchTag[]> {
    return this.observableTags.asObservable();
  }

  /**
   *  Notify a reload to the manager
   */
  notify() {
    this.observableTags.next(this.tags);
  }

  /**
   * revome a tag from the search and reload the search
   * @param id
   */
  removeTag(id: string) {
    const index = this.tags.findIndex((t) => t.name === id);
    if (index > -1) {
      this.tags.splice(index, 1);
      const data = this.getData();
      if (data && Object.hasOwn(data, 'id')) {
        data[id] = null;
      }
    }
    this.notify();
  }

  /**
   * add a tag in the search and reload the search
   * @param tag
   */
  addTag(tag: SearchTag) {
    const currentTag = this.tags.find((t) => t.name === tag.name);
    if (currentTag) {
      currentTag.value = tag.value;
    } else {
      this.tags.push(tag);
    }
    this.updateData(tag);
    this.notify();
  }

  /**
   * generate filters for the search
   */
  getFilters(): HttpFilter {
    const httpFilter = new HttpFilter();
    for (const tag of this.tags) {
      if (tag.value instanceof Date) {
        httpFilter.setFilters(
          tag.name,
          CommonUtils.convertDateToString(tag.value),
        );
      } else if (tag.value instanceof Array) {
        httpFilter.setFilters(tag.name, tag.value.join(','));
      } else if (tag.value instanceof Object) {
        httpFilter.setFilters(tag.name, tag.value.toString());
      } else {
        httpFilter.setFilters(tag.name, tag.value);
      }
    }
    return httpFilter;
  }
}
